export type OrgMember = { id: string; userId: string; role: 'owner' | 'admin' | 'member' };

function ownerCount(members: OrgMember[]): number {
  return members.filter((member) => member.role === 'owner').length;
}

/** An organization with no owner cannot be administered at all — never allow the last one out. */
export function canRemoveMember(members: OrgMember[], target: OrgMember): boolean {
  return target.role !== 'owner' || ownerCount(members) > 1;
}

export function canDemoteMember(members: OrgMember[], target: OrgMember): boolean {
  return target.role !== 'owner' || ownerCount(members) > 1;
}
